<template>
  <div class="protocol-container">
    <div class="protocol-header">
      <img src="@/assets/logo_black.png" alt="logo" class="logo" />
    </div>
    <div class="protocol-content">
      <h1 class="protocol-title">《长沙金镂机械科技有限公司信息化管理小程序》
        使用及个人信息授权协议</h1>
      <div class="protocol-body">
        <h3>重要提示</h3>
        <p>欢迎您注册并使用公司的《长沙金镂机械科技有限公司信息化管理小程序》系统（下称“本系统”）。请您在注册前审慎阅读本协议的全部条款。当您点击“同意”或完成注册流程时，即表示您已充分理解并同意接受本协议的全部约束。</p>
        <h3>一、 账户注册与管理</h3>
        <p>1、您应使用公司分配或认可的员工身份信息进行注册，并确保所提交的资料真实、准确、完整。</p>
        <p>2、您知晓并同意，您的系统账户密码是重要的身份凭证，您需自行妥善保管，并对通过该账户进行的所有操作及后果承担全部责任，但因公司系统安全漏洞或非因您过错导致的账户盗用除外。</p>
        <p>3、您的账户仅供本人为履行工作职责之目的使用，不得以任何形式转让、出借或允许他人使用。</p>
        <h3>二、 个人信息处理授权</h3>
        <p><strong>为向您提供本系统服务、实现企业信息化管理及保障系统安全，公司将依据《个人信息保护法》等法律法规，遵循合法、正当、必要和诚信原则，采取严格的安全保护措施，仅为实现上述明确目的处理您的个人信息，并承诺不将其用于任何未授权的其他用途。</strong></p>
        <p><span class="s_stitle">1、处理目的：</span>为向您提供本系统服务、实现企业信息化管理及保障系统安全，公司将依据《个人信息保护法》等法律法规，作为个人信息处理者处理您的个人信息。包括但不限于账户创建与认证、系统功能实现、工作流程管理、内部通讯、安全保障及统计分析。</p>
        <p><span class="s_stitle">2、信息范围：</span>包括您注册时提供的身份信息、使用系统过程中产生的操作日志与业务数据。</p>
        <div class="protocol-body-item"><span class="s_stitle">3、微信集成特别授权：</span><strong>为提供便捷登录与工作消息推送，本系统与微信公众号集成。您明确同意并授权：</strong>
          <div class="protocol-body-list">
            <div><strong>当您选择微信扫码登录或绑定时，公司可获取您的微信头像、昵称及对应的唯一OpenID，以完成在本系统的身份验证。</strong></div>
            <div><strong>公司可通过您关注的关联公众号，向您推送与工作相关的系统通知（如流程审批提醒）。</strong></div>
            <div><strong>您理解，除上述为实现功能所必需的信息外，公司不会通过此集成获取您的私人聊天记录、好友列表等其他微信个人信息。</strong></div>
          </div>
        </div>
        <p><span class="s_stitle">4、您的权利：</span>您有权查询、复制、更正、删除您的个人信息，以及撤回对本协议授权的同意。但撤回同意可能会影响您继续使用本系统的部分或全部功能。您可通过联系系统管理员行使上述权利。</p>
        <h3>三、 使用行为规范</h3>
        <p><span
            class="s_stitle">1、信息保护义务：</span><strong>您确认，通过本系统接触到的所有未公开的公司信息，包括但不限于业务流程、管理数据、技术信息、客户资料、内部通讯内容等，其所有权及相关权益均归属于公司，且仅限内部使用。您承诺，仅可为完成本系统授权的本职工作之目的使用该等信息，并应确保其不被任何非授权主体知悉。未经公司授权，您不得以任何形式（包括但不限于复制、转发、告知、展示）向任何第三方披露、传播，亦不得将其用于任何非授权用途。</strong>
        </p>
        <p><span class="s_stitle">特别授权：</span><strong>为履行经公司授权的售后职责，您可通过截图、复制等方式向相关人员提供必要的系统信息。但严禁将系统账户、密码或其他登录凭证交予任何第三方直接登录系统。
            此项义务长期有效，不因您停止使用本系统或劳动关系终止而解除。</strong>
        </p>
        <div class="protocol-body-item"><span class="s_stitle">2、行为规范：</span>您在使用本系统时，应遵守国家法律、法规及公司规章制度，并承诺：
          <div class="protocol-body-list">
            <div>不利用本系统从事任何违法违规或损害公司利益的活动。</div>
            <div>不发布、传输或存储侵犯他人知识产权、商业秘密或隐私权的信息。</div>
            <div>不进行任何可能干扰、破坏系统正常运行或未经授权访问系统数据的操作。</div>
            <div>您理解并确认，通过本系统（包括微信公众号入口）发送的工作指令与内容，均代表您本人的真实意思，并产生相应的工作责任。</div>
          </div>
        </div>
        <h3>四、 知识产权与数据权属</h3>
        <p>1、本系统及其包含的所有软件、技术、界面设计等知识产权，均归公司或其权利人所有。</p>
        <p>2、您在本系统内因执行工作任务所创建、提交、存储的任何数据、文档、信息等成果，其知识产权及一切相关权益均归属公司所有。</p>
        <h3>五、 免责与责任限制</h3>
        <p><strong>公司将尽商业上的合理努力保障本系统的稳定与安全。对于因必要的系统维护升级导致的服务暂停，公司应提前公告，但对于因此可能造成的数据损失，在法律允许的范围内不承担责任。对于因不可抗力、网络服务中断导致的服务暂停或数据损失，公司不承担责任。</strong></p>
        <h3>六、 协议的变更、中止与终止</h3>
        <p>1、公司有权根据业务与法律环境的变化修订本协议，修订内容将通过系统公告等方式公布。若您继续使用本系统，则视为接受修订。</p>
        <p>2、当您的劳动关系终止时，公司有权立即中止或注销您的账户，并依据法律法规及内部政策处理相关数据。</p>
        <h3>七、 法律适用与争议解决</h3>

        <p>本协议的解释、效力及争议解决，均适用中华人民共和国法律。</p>
        <p>双方因本协议发生的任何争议，应首先友好协商；协商不成的，任何一方均有权向公司所在地有管辖权的人民法院提起诉讼。</p>
        <h3>八、 其他</h3>
        <p>本协议未尽事宜，依照相关法律法规及公司规章制度执行。如本协议的任何条款被认定为无效或不可执行，不影响其他条款的效力。</p>
      </div>
      <div class="protocol-footer">
        <Button type="primary" @click="goBack">返回注册</Button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Protocol',
  methods: {
    goBack() {
      window.close()
      // 如果 window.close() 不起作用（非通过脚本打开的窗口），则返回上一页
      if (!window.closed) {
        this.$router.go(-1)
      }
    },
  },
}
</script>

<style lang="less" scoped>
h3 {
  color: #000;
}
strong {
  color: #000;
}
.s_stitle {
  color: #000;
  font-weight: bold;
  font-size: 15px;
}
.protocol-body-list div:before {
  content: '';
  display: inline-block;
  width: 10px;
  height: 10px;
  background: #000;
  border-radius: 50%;
  margin-right: 10px;
}
.protocol-container {
  min-height: 100vh;
  background: #f5f5f5;
}

.protocol-header {
  display: flex;
  max-width: 950px;
  align-items: center;
  padding: 10px 20px;
  margin: 0 auto;
  min-height: 100px;
  padding-left: 0px;

  .logo {
    height: 70px;
  }
}

.protocol-content {
  max-width: 950px;
  margin: 0 auto;
  background: #fff;
  border: 1px solid #dcdee2;
  padding: 30px 50px;
}

.protocol-title {
  font-size: 24px;
  color: #333;
  text-align: center;
  margin-bottom: 30px;
  padding-bottom: 20px;
  border-bottom: 1px solid #e8eaec;
}

.protocol-body {
  line-height: 2;
  color: #515a6e;
  font-size: 14px;
  overflow: auto;
  height: 500px;
  p {
    margin-bottom: 10px;
  }
}

.protocol-footer {
  margin-top: 40px;
  text-align: center;
  padding-top: 20px;
  border-top: 1px solid #e8eaec;
}
</style>
